export var subscriptionAdapterNotInitialized = 'Subscription adapter not initialized';
export var subscriptionAdapterAlreadyInitialized = 'Subscription adapter already initialized';
export var subscriptionAdapterClosed = 'Subscription adapter closed';
//# sourceMappingURL=subscribe-adapter-constants.js.map